<template>
    <div>test</div>
</template>
<script lang="ts" setup></script>
